package app.alefly.analytics


object HintType {
    const val TEXT = "text"
    const val ELIMINATE = "eliminate"
    const val UNKNOWN = "unknown"
}

interface AnalyticsTracker {
    fun track(event: AnalyticsEvent)
}

class InMemoryAnalyticsTracker : AnalyticsTracker {
    private val _events = mutableListOf<AnalyticsEvent>()
    val events: List<AnalyticsEvent> get() = _events.toList()

    override fun track(event: AnalyticsEvent) {
        _events += event
    }
}

object AnalyticsEvents :
    QuizEventFactory,
    SocialEventFactory,
    PageEventFactory {
    // Event builders live in the family interfaces (default methods) so call sites keep `AnalyticsEvents.x(...)`.
}
